import { successStories } from '@/mocks/homeData';

export default function SuccessStories() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-primary-50 text-primary-600 text-xs font-semibold rounded-full mb-3">
            Success Stories
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Lives Transformed by{' '}
            <span className="gradient-text">Your Generosity</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Real stories of hope, resilience, and transformation made possible by donors like you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {successStories.map((story, index) => (
            <div
              key={story.id}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-foreground-200/50 hover:shadow-sm transition-all duration-300"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={story.imageUrl}
                  alt={story.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h4 className="text-white font-heading text-sm font-bold">{story.name}</h4>
                  <p className="text-white/80 text-xs flex items-center gap-1">
                    <i className="ri-map-pin-line text-[10px]"></i>
                    {story.location}
                  </p>
                </div>
              </div>

              <div className="p-4">
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-4 mb-3">
                  {story.story}
                </p>
                <div className="flex items-start gap-2 p-3 rounded-xl bg-secondary-50">
                  <i className="ri-flashlight-line text-secondary-500 text-sm mt-0.5"></i>
                  <p className="text-secondary-700 text-[11px] font-medium leading-relaxed">{story.impact}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}